import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useAppContext } from "../../context/AppContext";
import {
  LayoutDashboard,
  Settings,
  LogOut,
  ChevronLeft,
  Layers,
  FileText,
  Code,
  FileUp,
} from "lucide-react";

function Sidebar() {
  const { logout } = useAuth();
  const { state, actions } = useAppContext();
  const { sidebarOpen } = state;
  const location = useLocation();

  const menuItems = [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: <LayoutDashboard size={20} />,
    },
    {
      name: "Shop Configuration",
      path: "/shop-configuration",
      icon: <Settings size={20} />,
    },
    {
      name: "Strategy Generator",
      path: "/strategy-generator",
      icon: <Code size={20} />,
    },
    {
      name: "Onboarding Files",
      path: "/onboarding-files",
      icon: <FileUp size={20} />,
    },
    // ,
    // {
    //   name: "Invoices",
    //   path: "/invoices",
    //   icon: <FileText size={20} />,
    // },
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Mobile backdrop */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-20 bg-black bg-opacity-50 lg:hidden"
          onClick={actions.toggleSidebar}
        ></div>
      )}

      {/* Sidebar */}
      <aside
        className={`fixed inset-y-0 left-0 z-30 w-64 bg-gray-900 text-white transition-transform duration-300 ease-in-out transform lg:translate-x-0 lg:static lg:inset-0 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between h-16 px-4 bg-gray-800">
          <div className="flex items-center">
            <Layers className="h-7 w-7 text-blue-400" />
            <span className="ml-2 text-xl font-semibold">Admin Panel</span>
          </div>
          <button
            onClick={actions.toggleSidebar}
            className="p-1 rounded-md lg:hidden hover:bg-gray-700"
          >
            <ChevronLeft size={20} />
          </button>
        </div>

        <div className="flex flex-col justify-between h-[calc(100%-4rem)]">
          <nav className="px-2 py-4">
            <ul className="space-y-1">
              {menuItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center px-4 py-3 rounded-lg transition-colors ${
                      isActive(item.path)
                        ? "bg-blue-600 text-white"
                        : "text-gray-300 hover:bg-gray-800 hover:text-white"
                    }`}
                  >
                    {item.icon}
                    <span className="ml-3">{item.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="px-4 py-6">
            <button
              onClick={logout}
              className="flex w-full items-center px-4 py-3 text-gray-300 rounded-lg hover:bg-gray-800 hover:text-white transition-colors"
            >
              <LogOut size={20} />
              <span className="ml-3">Logout</span>
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
